module.exports = __webpack_public_path__ + "img/bn6.8c975227.png";